import { LazyComponent, lazyWithNullFallback } from 'components/layout/routes';

export const Animation: LazyComponent<{ width?: string; height?: string }> = lazyWithNullFallback(
  async () => ({ default: (await import('./logo')).Logo })
);
